import { render } from "./Inputitems.vue?vue&type=template&id=75597316"
import script from "./Inputitems.vue?vue&type=script&lang=js"
export * from "./Inputitems.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__